import { defaultTheme } from '../garvan-react/Constants/Theme'
import { PaletteMode } from '@mui/material'
import { colourLookup } from '../Constants&Theme/ColourLookup'
import { tsLoginConfig } from '../Typescript/API_Response'

export function darkMode(loginConfig: tsLoginConfig | undefined) {
  return loginConfig?.UserPrefs?.DarkMode === 'true'
}

export function getColourPalette(loginConfig: tsLoginConfig) {
  const dark = darkMode(loginConfig)
  const userColour = loginConfig?.UserPrefs?.WindowColour
  return {
    ...defaultTheme,
    palette: {
      mode: dark ? ('dark' as PaletteMode) : ('light' as PaletteMode),
      ...(!dark ?
        {
          // palette values for light mode
          primary: {
            light: colourLookup(userColour).main['300'],
            main: colourLookup(userColour).main['500'],
            dark: colourLookup(userColour).main['700'],
            contrastText: colourLookup(userColour).contrast,
            heading: 'black',
          },
        }
      : {
          // palette values for dark mode
          primary: {
            light: colourLookup(userColour).main['200'],
            main: colourLookup(userColour).main['500'],
            dark: colourLookup(userColour).main['900'],
            contrastText: colourLookup(userColour).contrast,
            heading: 'white',
          },
        }),
    },
  }
}
